import * as React from 'react';
import { translate } from 'react-i18next';
import { useCallback } from 'react';

import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

const EmptyRoleModal = ({ t, closeModal, onOk }) => {

    const onOkClick = useCallback(async () => {
        closeModal();
        await onOk();
    }, [onOk, closeModal]);

    return (<MessageBoxFunctionalLayout
        title={t('role.withoutPermissions.title')}
        confirmText={t('role.save')}
        cancelText={t('role.continueEditing')}
        onOk={onOkClick}
        onCancel={closeModal}
        onClose={closeModal}
        theme="blue"
        dataHook="emptyRoleModal"
    >
        <Text size="medium" weight="thin">{t('role.withoutPermissions.body')}</Text>
    </MessageBoxFunctionalLayout>);
};

export default translate()(EmptyRoleModal);
